import { takeLatest, put, call, delay, race } from 'redux-saga/effects';

import {
  GET_INSURANCE_TYPE,
  GET_PAYMENT_DETAIL_REQUEST,
  GET_PAYMENT_DETAIL_SUCCESS,
} from 'redux/reducers/policy/actionTypes';
import {
  SET_OPEN_TOP_ALERT,
  SET_CONTENT_TOP_ALERT,
  SET_IS_NOT_LOADING,
  SET_DISABLE_BUTTON_LOGIN,
} from 'redux/reducers/global/actionTypes';

import {
  GET_PAYMENT_DUE_REQUEST,
  GET_INITIALPAYMENT_DUE_REQUEST,
  GET_CUBE_PAYMENT_DUE_REQUEST,
} from 'redux/reducers/payment/actionTypes';

import { paymentDetailApi, businessDateApi } from 'services/policy/policyApi';

import {
  login__message_PolNo_Bday_NotMatch,
  login__message_Server_Error,
  login__message_Group_Policy,
  login__message_Not_Available,
  amlaLimit,
} from 'helpers/constant';

import {
  checkIfInitialPayment,
  checkIfSourceFromLA,
  checkIfSourceFromCube,
  checkIfPlanCodeIsFastLane,
} from 'modules/Payment/helpers';

function* requestPaymentPolicyDetail(action) {
  const policy = yield call(paymentDetailApi, action.payload.data);

  let paymentInfo;
  let isEmptyPolicy = true;

  if (
    policy &&
    policy['policy-paymentinfo'] &&
    Array.isArray(policy['policy-paymentinfo'])
  ) {
    paymentInfo = policy['policy-paymentinfo'];
    isEmptyPolicy = paymentInfo[0] === undefined;
  }

  const isInitialPayment = isEmptyPolicy
    ? false
    : checkIfInitialPayment(policy['policy-paymentinfo'][0].PREMIUMSTATUSCODE);

  const params = { FILLER: 'A' };
  const { bo, timeout } = yield race({
    bo: call(businessDateApi, params),
    timeout: delay(5 * 1000),
  });

  if (policy && policy.response && policy.error) {
    const responseStatus = policy.response.status.toString();
    let topAlertMessage = `Sorry, ${policy.response.status} ${policy.response.statusText}`;
    switch (responseStatus) {
      case '422':
        topAlertMessage = login__message_PolNo_Bday_NotMatch;
        break;
      case '500':
        topAlertMessage = login__message_Server_Error;
        break;
      default:
        topAlertMessage = `Sorry, ${policy.response.status} ${policy.response.statusText}`;
    }

    const topAlertContent = {
      iconType: 'la la-exclamation-circle',
      message: topAlertMessage,
      iconClose: 'la la-times',
    };
    yield put({ type: SET_CONTENT_TOP_ALERT, topAlertContent });
    yield put({ type: SET_OPEN_TOP_ALERT });
    yield put({ type: SET_DISABLE_BUTTON_LOGIN });
    yield put({ type: SET_IS_NOT_LOADING });
    return;
  }

  const isPolicyClientTypeCorporate =
    policy['policy-paymentinfo'][0].CLTTYPE === 'C';

  if (isPolicyClientTypeCorporate) {
    const topAlertContent = {
      iconType: 'la la-exclamation-circle',
      message: login__message_Group_Policy,
      iconClose: 'la la-times',
    };
    yield put({ type: SET_CONTENT_TOP_ALERT, topAlertContent });
    yield put({ type: SET_OPEN_TOP_ALERT });
    yield put({ type: SET_DISABLE_BUTTON_LOGIN });
    yield put({ type: SET_IS_NOT_LOADING });
    return;
  }

  const isSourceFromLA = checkIfSourceFromLA(
    policy['policy-paymentinfo'][0].source
  );
  const isSourceFromCUBE = checkIfSourceFromCube(
    policy['policy-paymentinfo'][0].source
  );

  const isInitialPaymentFromLA = isInitialPayment && isSourceFromLA;
  const isPaymentFromLA = !isInitialPayment && isSourceFromLA;
  const isInitialPaymentFromCUBE = isSourceFromCUBE;

  const isPlanCodeFastLane = checkIfPlanCodeIsFastLane(
    policy['policy-paymentinfo'][0].PLANCODE
  );
  const billFrequency = parseFloat(
    policy['policy-paymentinfo'][0].BILLFREQUENCY
  );

  if (timeout || bo.error) {
    const topAlertContent = {
      iconType: 'la la-exclamation-circle',
      message: login__message_Server_Error,
      iconClose: 'la la-times',
    };
    yield put({ type: SET_CONTENT_TOP_ALERT, topAlertContent });
    yield put({ type: SET_OPEN_TOP_ALERT });
    yield put({ type: SET_DISABLE_BUTTON_LOGIN });
    yield put({ type: SET_IS_NOT_LOADING });
    return;
  }

  if (
    policy &&
    Array.isArray(policy['policy-paymentinfo']) &&
    policy['policy-paymentinfo'][0] !== undefined
  ) {
    if (isPlanCodeFastLane) {
      let fastlanePremium = 0;

      if (isInitialPaymentFromCUBE || isInitialPaymentFromLA) {
        fastlanePremium =
          billFrequency *
          parseFloat(policy['policy-paymentinfo'][0].INITIALPREMIUM);
      } else {
        fastlanePremium =
          billFrequency *
          parseFloat(policy['policy-paymentinfo'][0].TOTALINSTALLMENTPREMIUM);
      }

      if (fastlanePremium >= amlaLimit) {
        const topAlertContent = {
          iconType: 'la la-exclamation-circle',
          message: login__message_Not_Available,
          iconClose: 'la la-times',
        };
        yield put({ type: SET_CONTENT_TOP_ALERT, topAlertContent });
        yield put({ type: SET_OPEN_TOP_ALERT });
        yield put({ type: SET_DISABLE_BUTTON_LOGIN });
        yield put({ type: SET_IS_NOT_LOADING });
        return;
      }
    }

    yield put({
      type: GET_INSURANCE_TYPE,
      params: policy['policy-paymentinfo'][0].PLANCODE,
    });
    yield put({ type: GET_PAYMENT_DETAIL_SUCCESS, policy });
    if (isInitialPaymentFromLA) {
      yield put({
        type: GET_INITIALPAYMENT_DUE_REQUEST,
        params: {
          POLICYNUMBER: policy['policy-paymentinfo'][0].POLICYNUMBER,
          APPLICATIONNUMBER:
            '01' + policy['policy-paymentinfo'][0].POLICYNUMBER,
          location: '/',
        },
      });
    } else if (isPaymentFromLA) {
      yield put({
        type: GET_PAYMENT_DUE_REQUEST,
        params: {
          POLICYNUM: policy['policy-paymentinfo'][0].POLICYNUMBER,
          location: '/',
        },
      });
    } else if (isInitialPaymentFromCUBE) {
      yield put({
        type: GET_CUBE_PAYMENT_DUE_REQUEST,
        params: {
          POLICYNUMBER: policy['policy-paymentinfo'][0].POLICYNUMBER,
          APPLICATIONNUMBER:
            '01' + policy['policy-paymentinfo'][0].POLICYNUMBER,
          location: '/',
        },
      });
    }
  } else {
    const topAlertContent = {
      iconType: 'la la-exclamation-circle',
      message: login__message_PolNo_Bday_NotMatch,
      iconClose: 'la la-times',
    };
    yield put({ type: SET_CONTENT_TOP_ALERT, topAlertContent });
    yield put({ type: SET_OPEN_TOP_ALERT });
    yield put({ type: SET_DISABLE_BUTTON_LOGIN });
  }
  yield put({ type: SET_IS_NOT_LOADING });
}

function* getPolicy() {
  yield takeLatest(GET_PAYMENT_DETAIL_REQUEST, requestPaymentPolicyDetail);
}

export default getPolicy;
